/**
 * Crew utilization aggregates — one row per crew member with their assigned
 * hours and task count across a date range. Powers the /crew roster screen.
 */
import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';
import { CrewMemberWithUserSchema } from './users.js';
export const CrewUtilizationRowSchema = z.object({
    crew_member: CrewMemberWithUserSchema,
    // Aggregates over the requested window
    assigned_hours: z.number().min(0),
    task_count: z.number().int().min(0),
    // Per-day capacity (default 8h × days_in_window)
    capacity_hours: z.number().min(0),
    // Next assignment so we can show "next: Install · Mon 8a"
    next_task_id: UuidSchema.nullable(),
    next_task_title: z.string().nullable(),
    next_task_scheduled_start: IsoDateTimeSchema.nullable(),
});
export const CrewUtilizationResponseSchema = z.object({
    from_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    days_in_window: z.number().int().positive(),
    rows: z.array(CrewUtilizationRowSchema),
});
export const CrewUtilizationQuerySchema = z.object({
    from_date: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD'),
    to_date: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD'),
});
//# sourceMappingURL=crew-utilization.js.map